import {getUserConfig, saveUserConfig} from '@/api/interface-nav-config';

const nav = {
  state: {
    userName: '',
    navConfig:{},
    collectionConfig:[],
    currentPlatform:localStorage.getItem('currentPlatform')?JSON.parse(localStorage.getItem('currentPlatform')):{},
  },
  mutations: {
    SET_USER_NAME(state, userName){
      state.userName = userName;
    },
    SET_NAV_CONFIG(state,navConfig){
      state.navConfig = navConfig;
    },
    SET_COLLECTION_CONFIG (state, collectionConfig) {
      state.collectionConfig = collectionConfig;
    },
    EDIT_COLLECTION_CONFIG (state, config){
      if(Array.isArray(config)){
        state.collectionConfig = config;
        return;
      }else{
        let has = state.collectionConfig.some(e=>{
          return e.menuId == config.menuId && e.platformShopId == config.platformShopId;
        })
        if(has){
          // 修改
          state.collectionConfig.forEach((e,i)=>{
            if(e.menuId == config.menuId && e.platformShopId == config.platformShopId){
              state.collectionConfig.splice(i,1,config);
            }
          })
        }else{
          // 新增
          state.collectionConfig.push(config);
        }
      }
    },
    REMOVE_COLLECTION_CONFIG (state, config){
      let menuId = config.menuId;
      let platformShopId = config.platformShopId;
      state.collectionConfig.forEach((e,i)=>{
        if(e.menuId == menuId && e.platformShopId == platformShopId){
          state.collectionConfig.splice(i,1);
        }
      })
    },
    SET_CURRENT_PLATFORM (state, platformList){
      if(localStorage.getItem('currentPlatform'))return;
      platformList.forEach((item)=>{
        state.currentPlatform[item.id] = {
          currentShopId : item.shops[0]?item.shops[0].platformShopId:0,
          currentShopName : item.shops[0]?item.shops[0].name:''
        }
      })
    },
    EDIT_CURRENT_PLATFORM (state, command){
      state.currentPlatform[command.platformId].currentShopName = command.shopInfo.name;
      state.currentPlatform[command.platformId].currentShopId = command.shopInfo.platformShopId;
      localStorage.setItem('currentPlatform',JSON.stringify(state.currentPlatform));
      state.currentPlatform = JSON.parse(JSON.stringify(state.currentPlatform));
    }
  },
  actions: {
    async GetUserConfig({ commit }){
      var {code, data} = await getUserConfig({});
      if(code == 0){
        commit('SET_NAV_CONFIG', data);
        commit('SET_COLLECTION_CONFIG',data.userConfig.config);
        commit('SET_CURRENT_PLATFORM',data.platformList)
        console.log(data);
        return data;
      }
      return false;
    },
    async saveUserConfig({ state,commit,dispatch }, config){
      commit('EDIT_COLLECTION_CONFIG',config);
      var {code, data} = await saveUserConfig(JSON.stringify({'config':state.collectionConfig}));
      if(code == 0){
        return dispatch('GetUserConfig');
      }
    },
    async delUserConfig({ state,commit,dispatch }, config){
      commit('REMOVE_COLLECTION_CONFIG',config);
      var {code, data} = await saveUserConfig({'config':state.collectionConfig});
      if(code == 0){
        return dispatch('GetUserConfig');
      }
    }
  },
  getters: {

  }
}

export default nav



// WEBPACK FOOTER //
// ./src/store/modules/nav.js